import { SalesforceMetadata } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type SonarObjectsOptimisticChangeRequest = {
	salesforce: Partial<SalesforceMetadata>,
	sonarObjectIds: Array<number>
};

export type SonarObjectsOptimisticChangeState = SyncState<{
	salesforce: Partial<SalesforceMetadata>,
	sonarObjectIds: Record<number, boolean>
}>;

export const defaultSonarObjectsOptimisticChangeState: SonarObjectsOptimisticChangeState = { data: {
	salesforce: {},
	sonarObjectIds: {}
} };
